(function () {
  if (customElements.get("slib-sticky-atc")) return;

  class SlibStickyAtc extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute("data-slib-sticky-atc-body-mounted") && this.parentElement !== document.body) {
        this.setAttribute("data-slib-sticky-atc-body-mounted", "true");
        document.body.appendChild(this);
        return;
      }

      if (this.initialized) return;
      this.initialized = true;

      this.button = this.querySelector("[data-slib-sticky-atc-button]");
      this.variantSelect = this.querySelector("[data-slib-sticky-atc-variant-select]");
      this.productForm = document.getElementById(this.dataset.productFormId);
      this.mainSubmit = this.findMainSubmit();
      this.displayWhen = this.dataset.displayWhen || "after_scroll";
      this.displayAfter = Number(this.dataset.displayAfter) || 360;
      this.functionMode = this.dataset.function || "add_to_cart";
      this.isScrollMode = this.functionMode !== "add_to_cart";

      this.onScroll = this.onScroll.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);

      window.addEventListener("scroll", this.onScroll, { passive: true });
      window.addEventListener("resize", this.onScroll, { passive: true });
      this.button && this.button.addEventListener("click", this.onButtonClick);
      this.variantSelect && this.variantSelect.addEventListener("change", this.onVariantChange);

      this.onScroll();
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.initialized = false;

      window.removeEventListener("scroll", this.onScroll);
      window.removeEventListener("resize", this.onScroll);
      this.button && this.button.removeEventListener("click", this.onButtonClick);
      this.variantSelect && this.variantSelect.removeEventListener("change", this.onVariantChange);
    }

    onScroll() {
      if (this.displayWhen === "always") {
        this.show();
        return;
      }

      if (this.mainSubmit) {
        const rect = this.mainSubmit.getBoundingClientRect();
        if (rect.bottom < 0 || window.scrollY > this.displayAfter) {
          this.show();
        } else {
          this.hide();
        }
        return;
      }

      if (window.scrollY > this.displayAfter) {
        this.show();
      } else {
        this.hide();
      }
    }

    findMainSubmit() {
      if (this.productForm) {
        const submit = this.productForm.querySelector('[type="submit"], button[name="add"]');
        if (submit) return submit;
      }

      return Array.from(document.querySelectorAll(".product-form__submit, .main-product-atc, [name='add']")).find((button) => !this.contains(button)) || null;
    }

    show() {
      this.classList.add("is-visible");
      document.body.classList.add("slib-sticky-atc-visible");
      document.documentElement.style.setProperty("--sticky-atc-offset", `${this.offsetHeight}px`);
    }

    hide() {
      this.classList.remove("is-visible");
      document.body.classList.remove("slib-sticky-atc-visible");
      document.documentElement.style.setProperty("--sticky-atc-offset", "0px");
    }

    onVariantChange() {
      const option = this.variantSelect.options[this.variantSelect.selectedIndex];
      if (!option) return;

      const formInput = this.productForm && this.productForm.querySelector('[name="id"]');
      if (formInput) {
        formInput.value = option.value;
        formInput.dispatchEvent(new Event("change", { bubbles: true }));
      }

      const price = option.dataset.price;
      const comparePrice = option.dataset.comparePrice || "";

      this.querySelectorAll("[data-slib-sticky-atc-current-price]").forEach((node) => {
        node.textContent = price;
      });

      this.querySelectorAll("[data-slib-sticky-atc-compare-price]").forEach((node) => {
        node.textContent = comparePrice;
        node.hidden = !comparePrice;
      });

      this.querySelectorAll("[data-slib-sticky-atc-button-price]").forEach((node) => {
        node.textContent = `${price} •`;
      });

      const image = option.dataset.image;
      const imageNode = this.querySelector("[data-slib-sticky-atc-image]");
      if (image && imageNode) imageNode.src = image;
    }

    onButtonClick(event) {
      event.preventDefault();

      if (this.isScrollMode) {
        this.scrollToDestination();
        return;
      }

      this.addToCart();
    }

    scrollToDestination() {
      const selector = this.dataset.scrollDestination;
      const destination = selector && document.querySelector(selector);
      if (!destination) return;
      destination.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    async addToCart() {
      if (!this.button || this.button.disabled) return;

      const error = this.querySelector("[data-slib-sticky-atc-error]");
      if (this.productForm && typeof this.productForm.requestSubmit === "function") {
        this.productForm.requestSubmit(this.mainSubmit || undefined);
        return;
      }

      const formData = this.getFormData();
      if (!formData) return;

      this.button.classList.add("loading");
      this.button.disabled = true;
      if (error) {
        error.hidden = true;
        error.textContent = "";
      }

      try {
        const response = await fetch((window.routes && window.routes.cart_add_url) || "/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        });
        const result = await response.json().catch(() => null);

        if (!response.ok) {
          throw new Error((result && (result.description || result.message)) || "Could not add item to cart.");
        }

        document.dispatchEvent(new CustomEvent("slib:cart:add", { bubbles: true, detail: result }));

        const drawer = document.querySelector("slib-cart-drawer");
        if (drawer && typeof drawer.open === "function") {
          drawer.open();
        }
      } catch (caughtError) {
        if (error) {
          error.textContent = caughtError.message;
          error.hidden = false;
        }
      } finally {
        this.button.classList.remove("loading");
        this.button.disabled = false;
      }
    }

    getFormData() {
      if (this.productForm) {
        return new FormData(this.productForm);
      }

      const variantId = this.variantSelect ? this.variantSelect.value : null;
      if (!variantId) return null;

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", "1");
      return formData;
    }
  }

  customElements.define("slib-sticky-atc", SlibStickyAtc);
})();
